"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurriculumSerializer = void 0;
var models_1 = require("../../models");
/**
 * Serializes curriculums
 *
 * @author javier.perez
 */
var CurriculumSerializer = /** @class */ (function () {
    function CurriculumSerializer() {
    }
    CurriculumSerializer.prototype.serialize = function (_a) {
        var id = _a.id, name = _a.name, description = _a.description, grades = _a.grades, licensePolicyId = _a.licensePolicyId, addons = _a.addons;
        return new models_1.Curriculum({
            id: id,
            name: name,
            description: description,
            licensePolicyId: licensePolicyId,
            addons: addons,
            grades: (grades || []).map(function (grade) {
                return new models_1.Grade({
                    id: grade.id,
                    name: grade.name,
                    description: grade.description,
                    modules: (grade.modules || []).map(function (module) {
                        return new models_1.Module({
                            id: module.id,
                            name: module.name,
                            description: module.description,
                            topics: (module.topics || []).map(function (topic) {
                                return new models_1.Topic({
                                    id: topic.id,
                                    name: topic.name,
                                    description: topic.description,
                                });
                            }),
                            lessons: (module.lessons || []).map(function (lesson) {
                                return new models_1.Lesson({
                                    id: lesson.id,
                                    name: lesson.name,
                                    itemSets: (lesson.itemSets || []).map(function (itemSet) {
                                        return new models_1.ItemSet({
                                            id: itemSet.id,
                                            name: itemSet.name,
                                        });
                                    }),
                                });
                            }),
                        });
                    }),
                });
            }),
        });
    };
    return CurriculumSerializer;
}());
exports.CurriculumSerializer = CurriculumSerializer;
